import React, { useMemo} from "react";
import "./css/aboutMe.css";
import foto from "../../resources/img/AboutMe/foto.svg";
import frase from "../../resources/img/AboutMe/Frase.svg";
import Carrusel from "../../components/carrusel/carrusel";
import Divisorcenter from "../../components/divisorcenter/divisorcenter";
import Competitions from "../../components/competitions/competitions";
import DivisorLine from "../../components/divisorLine/divisorLine";
import { motion } from "motion/react";
import DivisorCenterWhite from "../../components/divisorCenterWhite/divisorCenterWhite";
import exhibitions from "./json/competitions.json";
import books from "./json/books.json";
import ImageCarousel from "../../components/imageCarousel/ImageCarousel";

const AboutMe = () => {
  const images = useMemo(() => [foto, foto], []);

  return (
    <motion.div
      key="empty"
      initial={{ y: 10, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: -10, opacity: 0 }}
      transition={{ duration: 0.2 }}
    >
      {/* Título */}
      <div className="container">
        <div className="row justify-content-center text-center mt-4">
          <div className="col-12">
            <div className="color-text-gris-hv">About me</div>
          </div>
        </div>

        {/* Texto + Imagen */}
        <div className="row mt-4 padding-text-hv">
          {/* Texto */}
          <div className="col-12 col-md-6 d-flex flex-column align-items-start justify-content-start ">
            <p className="color-text-body-hv">
              Helmut Hernández V, also known as "Hv Helmut," studied Graphic Design (BA)
              at Escuela de Artes y Letras and Oil Painting at
              the Faculty of Arts (ASAB), Universidad Distrital Francisco José de
              Caldas in Bogotá, Colombia. He currently works primarily on children's
              book&nbsp;illustrations&nbsp;and&nbsp;paintings.
            </p>

            <p className="color-text-body-hv">
              Based in Colombia, he has collaborated with authors and publishing
              houses around the world. He is especially drawn to: details, animals, plants, and
              nature elements-motifs that frequently appear in his&nbsp;illustrations.
            </p>

            <p className="color-text-body-hv">
              With each project, he seeks to grow and refine his personal
              style experimenting with: characters, colors, forms, and
              contrasting elements. Creative freedom is essential to his practice, and he
              enjoys exploring stories from different&nbsp;perspectives.
            </p>
          </div>

          {/* Imagen */}
          <ImageCarousel images={images} interval={2000} />
        </div>
      </div>

      {/* Sección libros */}
      <div className="py-5 mb-5 background-div-hv">
        <DivisorCenterWhite title="Books" subtitle="I have worked on:" />
        <div className="mt-4">
          <Carrusel books={books} />
        </div>
      </div>

      {/* Competencias */}
      <div className="margin-top-divisor container">
        <Divisorcenter
          title="Art competitions and exhibitions"
          description="I have had the opportunity to present my artwork in the fields of illustration and fine arts in:"
        />
        <Competitions  exhibitions={exhibitions}/>
      </div>

      {/* Imagen final */}
      <div className="container text-center">
        <DivisorLine lineSecond={false} />
        <div className=" d-flex justify-content-center">
          <img
            className="margin-frase de-flex"
            src={frase}
            alt=""
            width="100%"
            height="100%"
            onContextMenu={(e) => e.preventDefault()}
          />
        </div>
      </div>
    </motion.div>
  );
};

export default AboutMe;
